var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 143,
    viewBox: "0 0 152 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.654 51.3112C158.277 81.4508 146.249 120.696 123.996 135.702C101.742 150.579 69.5053 141.217 42.6813 121.081C15.8572 100.945 -5.31337 70.1645 1.18214 44.7702C7.67766 19.376 41.8393 -0.503305 74.6777 0.00970933C107.516 0.39447 138.911 21.2998 148.654 51.3112Z",
    fill: "#EEF1F9",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103 32C58.1689 32 51.7052 86.7692 53.1877 115.01L62.9723 121L71.8673 113.298L83.4309 121L93.2155 113.298L102.111 120.144C102.111 108.449 102.288 75.8154 103 32Z",
    fill: "#D4E2EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.702 122C102.702 99.1186 103.532 46.2373 103.532 34.7119C103.532 23.1864 110.234 22 114 22C95.1706 22 64.3846 22 53.1268 22C41.8689 22 40.9999 33.0169 41 36.4068V122L51.4286 114.373L62.7262 122L71.4167 114.373L82.7143 122",
    stroke: "#ACC1D5",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124 32.38V59.3137C120.797 56.1311 119.5 53.8955 113.5 53.8955C106.5 53.8955 103.24 60.0599 103.24 60.0599V33.245C103.24 23.557 110.2 22 114.035 22C120.678 22 124 27.19 124 32.38Z",
    fill: "#EEF1F9",
    stroke: "#ACC1D5",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8003 72.1699H91.1302",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8003 84.2798H75.5602",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2102 84.2798H91.1302",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8003 49.6797H59.9903",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9402 49.6797H91.1302",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.64 44.3333C78.4011 43.6744 77.9649 43.1001 77.3875 42.6843C76.8101 42.2685 76.1179 42.0301 75.4 42H70.6C69.6452 42 68.7295 42.3687 68.0544 43.0251C67.3793 43.6815 67 44.5717 67 45.5C67 46.4283 67.3793 47.3185 68.0544 47.9749C68.7295 48.6313 69.6452 49 70.6 49H75.4C76.3548 49 77.2705 49.3687 77.9456 50.0251C78.6207 50.6815 79 51.5717 79 52.5C79 53.4283 78.6207 54.3185 77.9456 54.9749C77.2705 55.6313 76.3548 56 75.4 56H70.6C69.8821 55.9699 69.1899 55.7315 68.6125 55.3157C68.0351 54.8999 67.5989 54.3256 67.36 53.6667",
    stroke: "#ACC1D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73 56.3333V60M73 38V41.6667V38Z",
    stroke: "#ACC1D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceEmpty);
export default __webpack_public_path__ + "static/media/invoiceEmpty.3ff7d162.svg";
export { ForwardRef as ReactComponent };